import React, { useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { LocationForm } from '../components/locations/LocationForm';

export const LocationEditPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  // TODO: Replace with Toolpad navigation
  const currentProject = null;
  const [formOpen, setFormOpen] = useState(true);
  
  const locationData = location.state?.location;
  const isNewLocation = !id; // If no ID in URL, we're creating a new location

  const handleSuccess = () => {
    // Navigate to project-aware locations page
    if (currentProject) {
      navigate(`/projects/${currentProject.id}/locations`);
    } else {
      navigate('/projects');
    }
  };

  const handleClose = () => {
    // Navigate to project-aware locations page
    if (currentProject) {
      navigate(`/projects/${currentProject.id}/locations`);
    } else {
      navigate('/projects');
    }
  };

  // For edit mode, we need location data. For new mode, we don't.
  if (!isNewLocation && !locationData) {
    return (
      <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
        <Typography variant="h6" color="error">
          Location data not found. Please navigate from the locations page.
        </Typography>
        <Button
          startIcon={<ArrowBack />}
          onClick={handleClose}
          variant="outlined"
          sx={{ mt: 2 }}
        >
          Back to Locations
        </Button>
      </Box>
    );
  }

  if (!currentProject) {
    return (
      <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
        <Typography variant="h6" color="error">
          Please select a project first.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={handleClose}
          variant="outlined"
          size="small"
        >
          Back to Locations
        </Button>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
          {isNewLocation ? 'Add New Location' : `Edit Location: ${locationData.name}`}
        </Typography>
      </Box>

      <LocationForm
        open={formOpen}
        onClose={handleClose}
        projectId={currentProject.id}
        editingLocation={isNewLocation ? undefined : locationData}
        onSuccess={handleSuccess}
      />
    </Box>
  );
};